import { Routes } from '@angular/router';
import { NotFoundComponent } from "./page/not-found/not-found.component";
import { CaptureComponent } from "./page/capture/capture.component";
import { ResultComponent } from "./page/result/result.component";
import { HomeComponent } from "./page/home/home.component";
import { ConfigComponent } from "./page/config/config.component";
import { ChooseComponent } from "./page/choose/choose.component";
import { GenerationSelectionComponent } from "./page/generation-selection/generation-selection.component";
import { GalleryComponent } from "./page/gallery/gallery.component";
import { Gallery2Component } from "./page/gallery2/gallery2.component";
import { Gallery3Component } from "./page/gallery3/gallery3.component";
import { Gallery4Component } from "./page/gallery4/gallery4.component";
import { Gallery40Component } from "./page/gallery40/gallery40.component";
import { Gallery5Component } from "./page/gallery5/gallery5.component";
import { Gallery6Component } from "./page/gallery6/gallery6.component";
import { Gallery7Component } from "./page/gallery7/gallery7.component";
import { Gallery8Component } from "./page/gallery8/gallery8.component";
import { Gallery9Component } from "./page/gallery9/gallery9.component";
import { Gallery10Component } from "./page/gallery10/gallery10.component";
import { GalleryQrComponent } from "./page/gallery-qr/gallery-qr.component";
import { DisabledComponent } from "./page/disabled/disabled.component";
import { GallerySearchComponent } from "./page/gallery-search/gallery-search.component";
import { Gallery1Component } from "./page/gallery1/gallery1.component";
import { ConfigurableGalleryComponent } from "./page/configurable-gallery/configurable-gallery.component";
import { PrintableGalleryComponent } from "./page/printable-gallery/printable-gallery.component";
import { PrintingComponent } from "./page/printing/printing.component";
import { DebugComponent } from "./page/debug/debug.component";
import { MclGalleryComponent } from "./page/mcl-gallery/mcl-gallery.component";
import {SurveyComponent} from "./page/survey/survey.component";
import {FormComponent} from "./page/form/form.component";

const projectRoutes: Routes = [
  { path: 'capture', component: CaptureComponent },
  { path: 'home', component: HomeComponent },
  { path: 'config', component: ConfigComponent },
  { path: 'survey', component: SurveyComponent },
  { path: 'form/:jobId', component: FormComponent },
  { path: 'themes', component: GenerationSelectionComponent },
  { path: 'gallery', component: GalleryComponent },
  { path: 'gallery1', component: Gallery1Component },
  { path: 'gallery2', component: Gallery2Component },
  { path: 'gallery3', component: Gallery3Component },
  { path: 'gallery4', component: Gallery4Component },
  { path: 'gallery40', component: Gallery40Component },
  { path: 'gallery5', component: Gallery5Component },
  { path: 'gallery6', component: Gallery6Component },
  { path: 'gallery7', component: Gallery7Component },
  { path: 'gallery8', component: Gallery8Component },
  { path: 'gallery9', component: Gallery9Component },
  { path: 'gallery10', component: Gallery10Component },
  { path: 'gallery-qr', component: GalleryQrComponent },
  { path: 'mcl-gallery', component: MclGalleryComponent },
  { path: 'gallery-search', component: GallerySearchComponent },
  { path: 'configurable-gallery', component: ConfigurableGalleryComponent },
  { path: 'printable-gallery', component: PrintableGalleryComponent },
  { path: 'printing', component: PrintingComponent },
  { path: 'choose', component: ChooseComponent },
  { path: 'disabled', component: DisabledComponent },
  { path: 'web-booth', redirectTo: 'home', pathMatch: 'full' },
  { path: 'debug', component: DebugComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'result/:jobId', component: ResultComponent },
  { path: 'multi-result/:jobId', component: ResultComponent }
];
export const routes: Routes = [
  { path: ':slug', children: projectRoutes },
  { path: '**', component: NotFoundComponent }
];
